/* 品质颜色 */
export const WeaponQualityColorDict = [
  {
    label: "Fundamentals",
    value: "#9A9EA2"
  },
  {
    label: "Common",
    value: "#E8F6FF"
  },
  {
    label: "Industry",
    value: "#b3d5ba"
  },
  {
    label: "Uncommon",
    value: "#00F873"
  },
  {
    label: "Rare",
    value: "#1998FF"
  },
  {
    label: "Epic",
    value: "#E253FF"
  },
  {
    label: "Legendary",
    value: "#FF557B"
  },
  {
    label: "Myth",
    value: "#FFC84F"
  }
];

export const gameOverview = [
  {
    label: "Game Modes",
    value: "game-modes"
  },
  {
    label: "Characters",
    value: "characters"
  },
  {
    label: "Weapons",
    value: "weapons"
  },
  {
    label: "Maps",
    value: "maps"
  },
  {
    label: "Weapon Cases",
    value: "weaponCases",
    target: true
  }
]

export const playStep = [
  {
    label: "Setup Account",
    value: "setup-account"
  },
  {
    label: "How to earn",
    value: "how-to-earn"
  },
  {
    label: "Character Details",
    value: "character-details"
  },
  {
    label: "Case Opening & Weapon Synthesis",
    value: "case-opening-weapon-synthesis"
  },
  {
    label: "Trading & Marketplace",
    value: "trading-marketplace"
  },
  {
    label: "In-Game Marketplace",
    value: "in-game-marketplace"
  }
]

// 武器库 武器信息
export const weaponCasesDict = [
  {
    adminLabel: "BASE",
    label: "Base",
    value: "#9A9EA2"
  },
  {
    adminLabel: "COMMON",
    label: "Common",
    value: "#E8F6FF"
  },
  {
    adminLabel: "Industrial",
    label: "Industrial",
    value: "#b3d5ba"
  },
  {
    adminLabel: "Uncommon",
    label: "Uncommon",
    value: "#00F873"
  },
  {
    adminLabel: "RARE",
    label: "Rare",
    value: "#1998FF"
  },
  {
    adminLabel: "EPIC",
    label: "Epic",
    value: "#E253FF"
  },
  {
    adminLabel: "Legendary",
    label: "Legendary",
    value: "#FF557B"
  },
  {
    adminLabel: "Mythical",
    label: "Mythical",
    value: "#FFC84F"
  }
]